import script from "./PropsBasics.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropsBasics.vue?vue&type=script&setup=true&lang=ts"

import "./PropsBasics.vue?vue&type=style&index=0&id=ca6292c8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca6292c8"]])

export default __exports__